import React from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { setUserActiveCount } from '../../../pages/login/authSlice';
import { MoodType } from '../../../utils/typeConstants';
import { MoodMeterRequest, usePostMoodmeterSubmitMoodMeterMutation } from '../MoodMeterSlice';
import MoodImageCard from '../moodImageCard/MoodImageCard';
import './MainMoodMeterModal.css';

export type MainMoodMeterModalProps = {
    empNum: string;
    supervisorId: string | null | undefined;
    onCloseModal: () => void;
};

export const MainMoodMeterModal = ({ empNum, supervisorId, onCloseModal }: MainMoodMeterModalProps) => {
    const dispatch = useDispatch();
    const [SubmitMoodMeterRequest] = usePostMoodmeterSubmitMoodMeterMutation();

    const handleSubmitMoodMeter = (moodType: string) => {
        const payload: MoodMeterRequest = {
            oracleId: empNum,
            supervisorId,
            moodType,
        };

        SubmitModMeter(payload);
    };

    const SubmitModMeter = (payload: MoodMeterRequest) => {
        SubmitMoodMeterRequest({ moodMeterRequest: payload })
            .unwrap()
            .then((res: any) => {
                if (res.data) {
                    dispatch(setUserActiveCount(1));
                    toast.success('Mood Submitted');
                } else {
                    toast.error('Failed');
                }
                onCloseModal();
            })
            .catch((err: any) => {
                console.log(err);
            });
    };

    return (
        <>
            <div className="container-mood-icons">
                <MoodImageCard
                    moodType={MoodType.Happy}
                    icon="HAPPY"
                    onClick={handleSubmitMoodMeter}
                    tooltip="Happy"
                />
                <MoodImageCard
                    moodType={MoodType.Tired}
                    onClick={handleSubmitMoodMeter}
                    icon="TIRED"
                    tooltip="Tired"
                />
            </div>
            <div className="container-mood-icons">
                <MoodImageCard
                    moodType={MoodType.Confused}
                    icon="CONFUSED"
                    tooltip="Confused"
                    onClick={handleSubmitMoodMeter}
                />
                <MoodImageCard
                    icon="QUESTION"
                    moodType={MoodType.Question}
                    tooltip="Question "
                    onClick={handleSubmitMoodMeter}
                />
            </div>
            <div className="container-mood-icons">
                <MoodImageCard
                    icon="DONTFEELWELL"
                    moodType={MoodType.DontFeelWell}
                    tooltip="Don't feel well"
                    onClick={handleSubmitMoodMeter}
                />
                <MoodImageCard
                    icon="UPSET"
                    moodType={MoodType.Upset}
                    tooltip="Upset"
                    onClick={handleSubmitMoodMeter}
                />
            </div>
        </>
    );
};
